import React, { useState, useEffect, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import "./footer.css";
import FooterImg from "../../images/logo/logo--footer.svg";
import NewsLetterForm from "./NewsLetterForm";

export default function FooterSec() {
	const [footer, setFooter] = useState(true);

	const location = useLocation();

	useEffect(() => {
		// console.log("location.pathname", location.pathname);
		if (["/produkt", "/service"].includes(location.pathname)) {
			setFooter(false);
		} else {
			setFooter(true);
		}
		window.scrollTo(-100, -100);
	}, [location.pathname, location.hash]);

	return (
		<div className="footer-sec">
			{footer ? (
				<div className="footer-con">
					<div className="footer-contakt">
						<h3>Kontakt</h3>
						<div className="contact-info">
							<ul className="contact-info">
								<li>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										fill="black"
										className="bi bi-telephone"
										viewBox="0 0 16 16"
									>
										<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
									</svg>
									<span>+49 (0) 30 700 127 060</span>
								</li>
								<li>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										fill="black"
										className="bi bi-envelope"
										viewBox="0 0 16 16"
									>
										<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
									</svg>
									<span>info@feingeist-beratung.de</span>
								</li>
							</ul>

							<ul className="contact-info">
								<li>
									<Link to="/kontakt">Kontaktformular</Link>
								</li>
								<li>
									<Link to="/impressum">Impressum / Datenschutz</Link>
								</li>
								<li>
									<Link to="/unternehmen/karriere">Karriere</Link>
								</li>
							</ul>
							<div className="contact-info">
								<p>Feingeist GmbH </p>
								<p>Quartier Potsdamer Platz</p>
								<p>Linkstraße 2 | Level 8 </p>
								<p>10785 Berlin</p>
							</div>
						</div>
					</div>
					<div className="footer-follow">
						<h3>Folgen Sie Uns</h3>

						<ul className="social-list">
							<li>
								<a href="https://linkedin.com/company/feingeist-beratung">
									<svg
										x="0px"
										y="0px"
										width="40"
										height="40"
										viewBox="0 0 24 24"
										style={{ fill: "#1A1A1A" }}
									>
										<path d="M 5 3 C 3.895 3 3 3.895 3 5 L 3 19 C 3 20.105 3.895 21 5 21 L 19 21 C 20.105 21 21 20.105 21 19 L 21 5 C 21 3.895 20.105 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 7.7792969 6.3164062 C 6.9222969 6.3164062 6.4082031 6.8315781 6.4082031 7.5175781 C 6.4082031 8.2035781 6.9223594 8.7167969 7.6933594 8.7167969 C 8.5503594 8.7167969 9.0644531 8.2035781 9.0644531 7.5175781 C 9.0644531 6.8315781 8.5502969 6.3164062 7.7792969 6.3164062 z M 6.4765625 10 L 6.4765625 17 L 9 17 L 9 10 L 6.4765625 10 z M 11.082031 10 L 11.082031 17 L 13.605469 17 L 13.605469 13.173828 C 13.605469 12.034828 14.418109 11.871094 14.662109 11.871094 C 14.906109 11.871094 15.558594 12.115828 15.558594 13.173828 L 15.558594 17 L 18 17 L 18 13.173828 C 18 10.976828 17.023734 10 15.802734 10 C 14.581734 10 13.930469 10.406562 13.605469 10.976562 L 13.605469 10 L 11.082031 10 z"></path>
									</svg>
								</a>
							</li>
						</ul>
					</div>
					<div className="footer-subs">
						<NewsLetterForm />
					</div>
				</div>
			) : (
				""
			)}
			{footer ? (
				<div className="footer-band">
					<img src={FooterImg} />
					<p className="footer-right">Copyright Feingeist GmbH </p>
				</div>
			) : (
				""
			)}
		</div>
	);
}
